export default __webpack_public_path__ + "static/media/p21.079b15f9.jpeg";